import React from 'react';
import AppNavigator from './AppNavigator';
import { StatusBar } from 'expo-status-bar';
import 'react-native-gesture-handler';

export default function App() {
  return (
    <>
      <AppNavigator />
      <StatusBar style="light" />
    </>
  );
}
